import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, WORKGROUP_KEY } from "@/lib/api";
import { resetLlmSettings } from "@/lib/llmSettings";

// null = checking, false = signed out, object = signed-in user (+ workgroups)
const AuthCtx = createContext(null);

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const me = await api.me();
      if (!localStorage.getItem(WORKGROUP_KEY) || !me.workgroups.some((w) => w.id === localStorage.getItem(WORKGROUP_KEY))) {
        localStorage.setItem(WORKGROUP_KEY, me.active_workgroup_id);
      }
      setUser(me);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onExpired = () => setUser(false);
    window.addEventListener("auth-expired", onExpired);
    return () => window.removeEventListener("auth-expired", onExpired);
  }, [refresh]);

  const login = async (email, password) => {
    localStorage.removeItem(WORKGROUP_KEY);
    resetLlmSettings();
    await api.login(email, password);
    await refresh();
  };
  const logout = async () => {
    await api.logout().catch((e) => console.warn("logout failed", e));
    localStorage.removeItem(WORKGROUP_KEY);
    resetLlmSettings();
    setUser(false);
  };
  const switchWorkgroup = (id) => {
    localStorage.setItem(WORKGROUP_KEY, id);
    window.location.reload();  // every view reloads its data for the new workgroup
  };

  return <AuthCtx.Provider value={{ user, login, logout, switchWorkgroup, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const activeWorkgroupId = () => localStorage.getItem(WORKGROUP_KEY);
